// Define Variables
const DiscountifyWsHost = '/apps/discountify'
const customerSearch = '/api/v1/customer_exists_on_shopify'
const fetchCustomer = '/api/v1/fetch_existing_customer'
const wsDiscountPath = '/api/v1/theme/fetch_ws_discount'
const wholesalerPreference = '/api/v1/theme/wholesaler_preference'
const createWholesalerPath = '/api/v1/wholesalers/create_wholesaler'

const customer = window.ShopifyAnalytics.meta.page.customerId;
const shopDomain = window.Shopify.shop || window.location.href.split('//')[1].split('/')[0];
var product = window.ShopifyAnalytics.meta.page.resourceId;
var productPrice = 0
var selectedVariantId = 0
const form = document.getElementById('create_customer');
var btn = document.getElementById("openWhAcModal");

function isFormPresent() {
  return modal.querySelector('form#create_customer') !== null;
}

if (btn) {
  var modal = document.getElementById("wholesaleModal");
  var closeBtn = document.getElementsByClassName("close")[0];

  btn.onclick = function () {
    modal.style.display = "block";

    if (isFormPresent() && customer !== undefined) {
      fetchCustomerData();
    }
  }

  closeBtn.onclick = function () {
    modal.style.display = "none";
  }

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
}

// Attach all startup event listeners and initialize logic when DOM is fully loaded
document.addEventListener('DOMContentLoaded', async () => {
  // Initialize modal container and listeners
  const modalContainer = document.getElementById("wholesaleModal");
  const closeModalButton = document.getElementsByClassName("close")[0];

  if (modalContainer) {
    modalContainer.style.display = 'none';
    document.body.appendChild(modalContainer);

    if (closeModalButton) {
      closeModalButton.addEventListener('click', (event) => {
        event.stopPropagation();
        modalContainer.style.display = 'none';
      });
    }

    modalContainer.addEventListener('click', (event) => {
      if (event.target === modalContainer) {
        modalContainer.style.display = 'none';
      }
    });
  } else {
    console.error('Modal container not found. Check the ID "iwt-modal-container".');
  }
});

const endPoint = `${DiscountifyWsHost}${customerSearch}`;
const wholesaleEmail = document.querySelector(".wholesale__email");
if (wholesaleEmail) {
  wholesaleEmail.onblur = function isEmailValid() {
    const email = wholesaleEmail.value.trim();
    if (!email) return;
    let url = `${endPoint}?shop=${shopDomain}&email=${email}&customer_id=${customer}`;
    fetch(url, {
      method: "GET",
      headers: {'Content-Type': 'application/json'},
    })
      .then(function (response) {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(function (data) {
        if (data.response.data.exists === true) {
          wholesaleEmail.value = "";
          wholesaleEmail.setCustomValidity("This email address is already associated with an account");
          wholesaleEmail.reportValidity();
        } else {
          wholesaleEmail.setCustomValidity("");
          wholesaleEmail.reportValidity();
        }
      })
      .catch(function (err) {
        console.error("Error:", err);
      });
  };
}

const wholesalerDiscount = document.getElementById('wholesalerDiscount')
if (wholesalerDiscount) {
  let url = `${DiscountifyWsHost}${wsDiscountPath}?shop=${shopDomain}&product_id=${product}`;
  if (customer !== undefined) {
    url += `&discount_customer_id=${customer}`;
  }
  fetch(url, {
    method: "GET",
    headers: {'Content-Type': 'application/json'}
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    }).then(function (data) {
    if (data.response.data.rule === null) {
      wholesalerDiscount.style.display = "none";
    } else {
      wholesalerDiscount.style.display = 'block';
      discounts = data.response.data
      wholesalerDiscount.innerHTML = `${displayWholesaleDiscount(discounts)}`;
      chooseOffers();
    }
  })
    .catch(function (err) {
      console.log(err)
    });
}


function displayWholesaleDiscount(discounts) {
  let discountHTML = '';

  if (discounts != '' && discounts.rule) {
    discountHTML += discounts.rule.map((option) => {
      const widgetData = option.widget_data;
      const borderColorCode = widgetData.borderColor;
      const hoverBorderColorCode = widgetData.hoverBorderColor
      const mainTextColorCode = widgetData.mainTextColor;
      const subTextColorCode = widgetData.subTextColor;
      const borderColorHex = `${widgetData.borderSize}px ${widgetData.borderStyle} ${borderColorCode}`;
      const borderRadius = widgetData.borderRadius;
      const hoverBorderColor = `${widgetData.hoverBorderSize}px ${widgetData.hoverBorderStyle} ${hoverBorderColorCode}`;

      selectedVariantId = ShopifyAnalytics.meta.product.variants[0].id
      productPrice = productPrice == 0 ? getPriceById(selectedVariantId) : productPrice
      const discountValue = parseFloat(option.value);
      const discountQuantity = parseInt(option.quantity, 10);
      const discountedPrice = (productPrice * discountQuantity) - discountValue;

      return `
        <div class="wholesale-discount-box"
          style="border: ${borderColorHex}; border-radius: ${borderRadius}px"
          onMouseEnter="this.style.border = '${hoverBorderColor}'"
          onMouseLeave="this.style.border = '${borderColorHex}'">
          <div class="hidden-content">
            <div class="ws-discount-code">${option.code}</div>
            <div class="variant-id">${selectedVariantId}</div>
            <div class="prod-qty">${option.quantity}</div>
          </div>

          <div class="main-text" style="font-size: ${widgetData.mainTextSize}px; color: ${mainTextColorCode}">Buy ${option.quantity} @ ${discountedPrice.toFixed(2)} <span class="line-through">${(productPrice * discountQuantity).toFixed(2)}</span></div>
          <div class="sub-text-div">
            <div class="sub-text" style="font-size: ${widgetData.subTextSize}px; color: ${subTextColorCode}; margin-top: ${widgetData.subTextMargin}">Save ${option.currency} ${discountValue}</div>
          </div>
        </div>`;
    }).join('<br>');
  }

  return discountHTML;
}

function getPriceById(variantId) {
  var variant = ShopifyAnalytics.meta.product.variants.find(function (v) {
    return v.id == variantId;
  });

  return variant ? variant.price / 100 : null;
}

if (btn) {
  let url = `${DiscountifyWsHost}${wholesalerPreference}?shop=${shopDomain}`;
  fetch(url, {
    method: "GET",
    headers: {'Content-Type': 'application/json'}
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    }).then(function (data) {
    if (data.response.data.shop_wholesaler_preference === true) {
      btn.style.display = "block";
    } else {
      btn.style.display = 'none';
    }
  })
    .catch(function (err) {
      console.log(err)
    });
}

function chooseOffers() {
  var wholesale_products = document.getElementsByClassName('wholesale-discount-box');
  for (var i = 0; i < wholesale_products.length; i++) {
    wholesale_products[i].onclick = function () {
      var details = fetchProductDetails(this);
      addItemToCheckout(details.product_details, details.wsDiscountCode)
    };
  }
}

function fetchProductDetails(selected_offers) {
  var variantIdDiv = selected_offers.getElementsByClassName('variant-id')[0].innerHTML;
  var quantity = selected_offers.getElementsByClassName('prod-qty')[0].innerHTML;
  var wsDiscountCode = selected_offers.getElementsByClassName('ws-discount-code')[0].innerHTML;

  return {product_details: {id: variantIdDiv, quantity: quantity}, wsDiscountCode: wsDiscountCode};
}

function addItemToCheckout(product_details, wsDiscountCode) {

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(product_details)
  })
    .then(response => {
      window.location.href = '/checkout?discount=' + wsDiscountCode
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function fetchCustomerData() {
  let fetchCustomerUrl = `${DiscountifyWsHost}${fetchCustomer}?customer_id=${customer}&shop=${shopDomain}`;
  fetch(fetchCustomerUrl, {
    method: "GET",
    headers: {'Content-Type': 'application/json'},
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (data) {
      if (data.response.data.exists === true) {
        let customerData = data.response.data.customer;
        document.getElementById("first_name").value = customerData.firstName;
        document.getElementById("last_name").value = customerData.lastName;
        document.getElementById("email").value = customerData.email;
        document.getElementById("phone").value = customerData.defaultAddress.phone;
        document.getElementById("company").value = customerData.defaultAddress.company;
        document.getElementById("address1").value = customerData.defaultAddress.address1;
        document.getElementById("address2").value = customerData.defaultAddress.address2;
        document.getElementById("city").value = customerData.defaultAddress.city;
        document.getElementById("country").value = customerData.defaultAddress.country;
        document.getElementById("zip").value = customerData.defaultAddress.zip;
        document.getElementById("password").closest('.form-row').remove(); // removed password field for existing customer
        let createCustomerUrl = `${DiscountifyWsHost}${createWholesalerPath}?shop=${shopDomain}&customer_id=${customer}`;
        form.action = createCustomerUrl;
      }
    })
    .catch(function (err) {
      console.error("Error:", err);
    });
}

if (form) {
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(form); // Collect form data
    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(response => response.text())
      .then(data => {
        console.log('Success:', data);

        // Close the modal
        var modal = document.getElementById("wholesaleModal");
        modal.style.display = "none";

        // Reload the page
        location.reload();
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
}
;